import { docReady } from "./helpers.js"
import Iubenda from "./iubenda.js"

docReady(() => {
  const galaxyNetworkInserter = window.galaxyNetworkInserter
  const conf = galaxyNetworkInserter.managerConfig

  if (
    typeof conf === "undefined" ||
    typeof conf === null ||
    conf.data.status === "error"
  )
    return
  if (conf.iubenda.active === true) {
    const iubenda = new Iubenda(conf.iubenda)
    iubenda.load()
  }

  window.addEventListener("IubendaConsentGiven", function () {
    // Check if the page have proprety to disable ads
    if (
      document.body.hasAttribute("data-no-ads") &&
      document.body.dataset.noAds === "1"
    )
      return

    import("./provider").then((adv) => {
      const bidder = new adv.providers.Bidder({
        adManager: conf.adManager,
        amazonHeaderBidding: conf.amazonHeaderBidding,
        demandManager: conf.demandManager,
        viralize: conf.viralize,
      })
      adv.register(bidder)
      adv.load()
    })
  })
})
